var _rect, _rect2, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkdin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 5.05263,
    fill: "#000E3F"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_20_86",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 3,
    y: 3,
    width: 19,
    height: 19
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 3,
    width: 18.1565,
    height: 18.1565,
    fill: "url(#pattern0_20_86)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_20_86)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 5.26953,
    y: 4.51318,
    width: 15.887,
    height: 15.887,
    fill: "#F5F5F5"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_20_86",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_20_86",
    transform: "scale(0.0104167)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_20_86",
    width: 96,
    height: 96,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGAAAABgCAYAAADimHc4AAAACXBIWXMAAAsTAAALEwEAmpwYAAAC60lEQVR4nO2dvWsUURTFf4qsgp2FjSBYSiLYaGNhJYgSsBAbLQRBG8FGSGMh9i6J8eOf8AsbLTSdCjYW0UawEwxamQQViV4ZeGAQdvftTmbu3bfnB7dZmAf3nPfOm9nZnQEhhBBCCCGEEEIIIfI5AMwD74A1wAqvtdTrHDDtOVG2A3eB3wFEMaeqer8DdDzEXwwggAWpF22bcC9A0xasbreZ+ZMcO9aj1oGpNgyYD9CsBa1uGwa8D9CoBa2lNgxYDdCoBa2VNgzwbtKClwxABrjPQtMK8BfCFEH+YphDhd8DXgJXgVPADHAlfeYtXPEG/ADO9Bn3fLqa9BawWAMuZIx9LYCARRrwCdiaMfZO4HsAEYsz4OEQ478JIGJxBtwfYvzXAUQszoAPQ9zoWQkgYnEGVHUiY+zLAQQs1oAvwME+486kU1VvAYs1oKqf6XbmcWB/MuQc8AT4E0C84g2YhGoc7wYteMkAZID7LDStAH8hTBH0T4TPm7jHnM4cZ2HDMb+AR8Al4BCwO1307QD2AWeBpyXvAZ4GPAD2Zh5zEliWAWyaATcYnuoXz1+1AqhtwDFGp1oJiiDqGVCXx9oDcDXgqAzA1YAtwEedBVHbgG0p02fTN645t0br/A+iccblNLRiD/D2v+OfDfFvlosygJENqCLkVQ8Br2eOcVgGMLIBR/qIt5wMGkR1lawIYjQDZgeIV4k7iF0ygJFXQHeAAVW85GzgWgHU+y6oV1URlYMMQAaM5WnoglaADGgErQB0JZyDIkgR1AyKIBRBOSiCFEHNoAhCEZSDIkgR1AyKIBRBOSiCJrQax7tBC14yABngPgtNK8BfCFME+YthDqU9ABngPgut5BWgB7fSU/xvbRigRxfj++jiuQDL3ILWzTYMmC7k4Xo2ro+vJ722w7thC1a3aJFOem2Hd9MWpJ57vEemk17bMclxtJ5mfuvib2Qq/RR8aUJOUVdTr902M18IIYQQQgghhBBCMPb8BX6COx6mhkfeAAAAAElFTkSuQmCC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkdin);
export default __webpack_public_path__ + "static/media/linkdin.1ae25165c3fffd36c7a970322e2b6383.svg";
export { ForwardRef as ReactComponent };